// ** Initial user ability
export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth'
  },
  {
    action: 'manage',
    subject: 'User'
  }
]

export const _ = undefined
